import React from 'react';
import useGridThemes from './useGridThemes.hook';
import { Button, Grid, Menu, MenuItem } from '@mui/material';
import MuiIcon from '../../../../../../../../shared/styles/mui/helpers/mui-icon.helper';
import GridThemeColorComponent from './grid-theme-color.component';
import IGridTheme from './IGridTheme';
import useWizardReportDataContext from '../../../../../contexts/useWizardReportData.context';

export default function GridThemePickerComponent({
    // onChange
}: {
        // onChange: (gridTheme: IGridTheme) => void
    }) {

    const { wizardData, applyReportData } = useWizardReportDataContext();



    const { gridThemes } = useGridThemes();

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuItemClick = (e: React.MouseEvent<HTMLElement>, index: number) => {
        const gridTheme = gridThemes[index];
        applyReportData({
            ...wizardData,
            reportSpecification: {
                ...wizardData.reportSpecification,
                styleInformation: {
                    ...wizardData.reportSpecification.styleInformation,
                    borderColor: gridTheme.borderColor,
                    headerColor: gridTheme.headerBgColor,
                    headerForegroundColor: gridTheme.headerFgColor,
                    itemColor: gridTheme.defaultRowBgColor,
                    itemForegroundColor: gridTheme.defaultRowFgColor,
                    alternatingItemColor: gridTheme.alternateRowBgColor,
                    alternatingItemForegroundColor: gridTheme.alternateRowFgColor,
                }
            }
        })
        setAnchorEl(null);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (<>

        <Button variant='text' color='secondary' sx={{ textTransform: 'none' }}
            startIcon={MuiIcon.PALLETTE({ sx: { color: (t) => t.palette.primary.main } })}
            endIcon={MuiIcon.ARROW_DROP_DOWN()}
            onClick={handleOpenMenu}
        >Select a Theme</Button>

        <Menu id="lock-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}

        >
            {gridThemes.map((gridTheme, index) => (
                <MenuItem
                    sx={{ width: '256px', borderBottom: (t) => `1px solid ${t.palette.divider}` }}
                    key={gridTheme.name}
                    onClick={(event) => handleMenuItemClick(event, index)}
                >
                    <Grid container direction='row' alignItems='center'>
                        <Grid item xs={4} sx={{ pr: 1 }}>{gridTheme.name}</Grid>
                        <GridThemeColorComponent color={gridTheme.headerBgColor} />
                        <GridThemeColorComponent color={gridTheme.alternateRowBgColor} />
                        <GridThemeColorComponent color={gridTheme.defaultRowBgColor} />
                        <GridThemeColorComponent color={gridTheme.borderColor} />
                    </Grid>

                </MenuItem>
            ))}
        </Menu>

    </>);
}